import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EditableTrayComponent } from './editable-tray.component';

const routes: Routes = [
    {
        path: '',
        component: EditableTrayComponent
    },{
        path: ':filter',
        component: EditableTrayComponent
    }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EditableTrayRoutingModule { }
